'use strict';
const Ajax = require('common/infra/ajax');

class API {
    constructor() {
        this._cursors = {};
        this._mores = {};
        this._rootCache = {};
    }

    /**
     * Project 配下の Root Container を取得する
     *
     * @param projectID
     * @returns {*}
     */
    getRootContainer(projectID) {
        if(!this._rootCache[projectID]) {
            this._rootCache[projectID] = Ajax.GET(`/api/projects/${projectID}/data-containers`);
        }
        return this._rootCache[projectID];
    }

    /**
     * 指定された親Container配下の Data Container 一覧を取得する
     *
     * @param projectID
     * @param parentContainerID
     */
    fetchChildContainers(projectID, parentContainerID) {
        const path = `/api/projects/${projectID}/data-containers/${parentContainerID}/child-containers`;
        return Ajax.GET(path);
    }

    fetchContainer(projectID, containerID) {
        const path = `/api/projects/${projectID}/data-containers/${containerID}`;
        return Ajax.GET(path);
    }
}

module.exports = new API();



// WEBPACK FOOTER //
// ./data/infra/api/container/index.js